import axios from 'axios'
import Vue from 'vue'
import { Message, Loading } from 'element-ui'

// 提示错误
function errorMessage (str) {
  Message && Message({
    message: str || '系统发生未知错误',
    showClose: true,
    duration: 4000,
    type: 'error'
  })
}
// 请求的错误消息
const errorOBJ = {
  // 403: '请求无效',
  // 402: '请求已过期',
  400: '（错误请求） 服务器不理解请求的语法。',
  401: '（未授权） 请求要求身份验证。 对于需要登录的网页，服务器可能返回此响应。',
  403: '（禁止） 服务器拒绝请求。',
  404: '（未找到） 服务器找不到该请求。',
  405: '（方法禁用） 禁用请求中指定的方法。',
  406: '（不接受） 无法使用请求的内容特性来响应请求。',
  407: '（需要代理授权） 此状态代码与 401（未授权）类似，但指定请求者应当授权使用代理。',
  408: '（请求超时） 服务器等候请求时发生超时。',
  409: '（冲突） 服务器在完成请求时发生冲突。 服务器必须在响应中包含有关冲突的信息。',
  410: '（已删除） 如果请求的资源已永久删除，服务器就会返回此响应。',
  411: '（需要有效长度） 服务器不接受不含有效内容长度标头字段的请求。',
  412: '（未满足前提条件） 服务器未满足请求者在请求中设置的其中一个前提条件。',
  413: '（请求实体过大） 服务器无法处理请求，因为请求实体过大，超出服务器的处理能力。',
  414: '（请求的 URI 过长） 请求的 URI（通常为网址）过长，服务器无法处理。',
  415: '（不支持的媒体类型） 请求的格式不受请求页面的支持。',
  416: '（请求范围不符合要求） 如果页面无法提供请求的范围，则服务器会返回此状态代码。',
  417: '（未满足期望值） 服务器未满足"期望"请求标头字段的要求。',
  500: '（服务器内部错误） 服务器遇到错误，无法完成请求。',
  501: '（尚未实施） 服务器不具备完成请求的功能。 例，服务器无法识别请求方法。',
  502: '（错误网关） 服务器作为网关或代理，从上游服务器收到无效响应。',
  503: '（服务不可用） 服务器目前无法使用（由于超载或停机维护）。 通常，这只是暂时状态。',
  504: '（网关超时） 服务器作为网关或代理，但是没有及时从上游服务器收到请求。',
  505: '（HTTP 版本不受支持） 服务器不支持请求中所用的 HTTP 协议版本。'
}
let LoadingService
const baseURL = window.ServerUrl
const service = axios.create({
  baseURL,
  timeout: 10 * 60000,
  withCredentials: false,
})

service.interceptors.request.use(
  config => {
    // 判断是否需要loading
    if (config.loading) {
      LoadingService = Loading.service({
        lock: true,
        text: typeof (config.loading) === 'string' ? config.loading : '努力加载中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.6)'
      })
    }
    config.cancelToken = new axios.CancelToken(c => {
      Vue.$requestList.push(c)
    })
    config.headers['Content-Type'] = 'application/json;charset=utf-8'
    return config
  },
  error => {
    errorMessage(error.message)
  }
)

// response interceptor
service.interceptors.response.use(
  response => {
    if (LoadingService) LoadingService.close()
    if (response.data.code === '200') {
      return response.data.data
    } else if (response.status === 200) {
      return response.data
    }
    return response
    // const { Data, Success, Message } = response.data
    // if (response.config.tips && !Success) {
    //   // 提示错误，参数中含有tips才提示
    //   errorMessage(typeof response.config.tips === 'string' ? response.config.tips : Message)
    // }

    // switch (res.errorCode) {
    //   case 0:
    //     return res.data
    //   case 101:
    //     router.push('/login')
    //     Promise.reject(res)
    //     break
    //   default:
    //     console.error(res)
    //     errorMessage(res.errorMsg || errorOBJ[res.errorCode] || '系统错误')
    // }
    // return Data
  },
  error => {
    if (error && error.__CANCEL__) {
      console.warn('--请求已被取消-------')
    } else {
      console.log('--error------------', error)
      const status = error.response.status
      if (LoadingService) LoadingService.close()
      errorMessage(errorOBJ[status] || error.message)
    }
  }
)

export default service
